import { render, staticRenderFns } from "./ReferralPathwayForm.vue?vue&type=template&id=3fb4d43a&scoped=true"
import script from "./ReferralPathwayForm.vue?vue&type=script&lang=js"
export * from "./ReferralPathwayForm.vue?vue&type=script&lang=js"
import style0 from "./ReferralPathwayForm.vue?vue&type=style&index=0&id=3fb4d43a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb4d43a",
  null
  
)

export default component.exports